import { render, staticRenderFns } from "./WellbeingCarousel.vue?vue&type=template&id=0d848347&"
import script from "./WellbeingCarousel.vue?vue&type=script&lang=js&"
export * from "./WellbeingCarousel.vue?vue&type=script&lang=js&"
import style0 from "./WellbeingCarousel.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports